export default {
  storyboardScreens: [
    {
      imageFile: "06a_Share_Persona.jpg",
      title: "Privacy & Permissions",
      text:
        "The customer experience doesn’t end with the purchase. It begins with the customer fully in control of her data.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "SR06a",
      hasNext: true,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "06b_Share_Gigya01.jpg",
      title: "Privacy & Permissions",
      text:
        "Lisa can log into her Lucia-Daniel preference centre to manage her consent at any time.",
      coordinates: { left: "317", top: "610", right: "447", bottom: "5" },
      screenId: "SR06b",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "06d_Share_Persona.jpg",
      title: "Customer Profile",
      text:
        "Click NEXT to learn how Maria continues her relationship with Lisa, converting her from customer to a fan.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "SR06d",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "06e_Share_Gigya02.jpg",
      title: "Customer Profile",
      text:
        "A complete view of the customer enables Maria to see all the engagement activities along the entire customer journey, offering valuable insights on what is the next best action to continue her relationship with Lisa.",
      coordinates: { left: "1", top: "0", right: "1", bottom: "432" },
      screenId: "SR06e",
      hasNext: false,
      highlightPosition: "Top-Right"
    }
  ]
};
